export default {
    name: 'ContactBanner',
    setup() {}
}
